// ============================================================================
// API Configuration — Re-exports from centralized app config
// ============================================================================

export { APP_CONFIG } from '../config/app.config';
export { GENAI_BASE_API_URL, ENDPOINTS } from './endPoints';

// Convenience re-exports
import { APP_CONFIG } from '../config/app.config';

export const AUTH_BASE_API_URL = import.meta.env.VITE_AUTH_API_URL as string;
export const GENAI_API_BASE_URL = APP_CONFIG.BASE_URL;
export const REQUEST_TIMEOUT = 30_000;

export const API_HEADERS = {
  'Content-Type': 'application/json',
  'Accept': 'application/json',
} as const;
